import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSmartModalComponent, NgxSmartModalService } from 'ngx-smart-modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { AbstractBaseComponent } from 'src/app/model/AbstractBaseComponent';
import { SharedService } from 'src/app/shared/shared.service';

import {
  InstructorOrTutorDTO,
  ListInstructorsOrTutorsDTO,
  SelectDTO,
  TIPOLOGIA,
} from './../../../../model/newModel';
import { AUtenteService } from './../a-utente.service';

@Component({
  selector: 'app-list-utenti',
  templateUrl: './list-utenti.component.html',
  styleUrls: ['./list-utenti.component.css'],
})
export class ListUtentiComponent
  extends AbstractBaseComponent
  implements AfterViewInit, OnInit, OnDestroy {
  listUtenti: ListInstructorsOrTutorsDTO;
  abilitatoDisabilitato: string;
  idGruppo: number;
  gruppo: string;
  tempListUtenti: InstructorOrTutorDTO[];
  tipologieAbilitatoDisabilitato: SelectDTO[];
  tipologieGruppo: SelectDTO[];
  gruppi: SelectDTO[];
  showUtenti: boolean;

  filtroFE(abilitatoDisabilitato: string, idGruppo: string) {
    this.listUtenti.instructorsOrTutors = this.tempListUtenti.filter(
      (utente: InstructorOrTutorDTO) => {
        let filterActive = true;
        let filterGruppo = true;
        if (abilitatoDisabilitato) {
          switch (abilitatoDisabilitato) {
            case TIPOLOGIA.ABILITATI:
              filterActive = utente.active === true;
              break;
            case TIPOLOGIA.DISABILITATI:
              filterActive = utente.active === false;
              break;
          }
        }
        if (idGruppo) {
          filterGruppo = utente.gruppo.id === Number(idGruppo);
        }
        return filterActive && filterGruppo;
      }
    );
  }

  ngOnInit(): void {
    this.tipologieAbilitatoDisabilitato = this.sharedService.allSelectTipologieAbilitatoDisabilitato();
    super.ngOnInit();
    this.aUtenteService.selectGruppi().subscribe(
      (result) => {
        const empty = new SelectDTO();
        empty.value = '';
        empty.viewValue = 'TUTTI';
        this.gruppi = result.list.filter(
          (item) => item.viewValue !== 'STUDENT'
        );
        this.gruppi.unshift(empty);
      },
      (error) => {
        console.log('Errore selectGruppi');
      }
    );
    this.getListUtenti();
  }

  getListUtenti() {
    this.spinner.show();
    this.aUtenteService.search().subscribe(
      (result) => {
        this.listUtenti = result;
        if (this.listUtenti.instructorsOrTutors.length > 0) {
          this.showUtenti = true;
        } else {
          this.showUtenti = false;
        }
        this.tempListUtenti = Object.assign(
          [],
          this.listUtenti.instructorsOrTutors
        );
        this.spinner.hide();
      },
      (error) => {
        this.spinner.hide();
        console.log('Errore search');
      }
    );
  }

  goToEditDetail(id: number) {
    this.router.navigate(['/a-utente/modifica'], { queryParams: { id } });
  }

  disabilita(id: number) {
    this.aUtenteService.abilitaDisabilita(id, false).subscribe((result) => {
      if (result) {
        this.sharedService.openOkModal();
        this.modalSubscribe = this.ngxSmartModalService
          .getModal('okModal')
          .onClose.subscribe((modal: NgxSmartModalComponent) => {
            this.getListUtenti();
          });
      }
    });
  }

  disabilitaAbilita(id: number, value: boolean) {
    if (value) {
      this.disabilita(id);
    } else {
      this.abilita(id);
    }
  }

  abilita(id: number) {
    this.aUtenteService.abilitaDisabilita(id, true).subscribe((result) => {
      if (result) {
        this.sharedService.openOkModal();
        this.modalSubscribe = this.ngxSmartModalService
          .getModal('okModal')
          .onClose.subscribe((modal: NgxSmartModalComponent) => {
            this.getListUtenti();
          });
      }
    });
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
  }

  constructor(
    private spinner: NgxSpinnerService,
    public ngxSmartModalService: NgxSmartModalService,
    public router: Router,
    private sharedService: SharedService,
    private aUtenteService: AUtenteService
  ) {
    super();
  }
}
